import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Dropdown, Icon, Label, Segment, Popup, Checkbox } from "semantic-ui-react";
import DropDownItemFolder from "./DropDownItemFolder";
import CancelNurseHelpModal from "features/FolderManager/components/modals/CancelNurseHelpModal";
import moment from "moment";

const HelpFolderDropDown = ({
	nurseHelp,
	myNurseFolderHelps,
	statusWaitingFolderHelps,
	toggleNurseHelp,
	focusFolderManager,
	acceptSupportFolderHelp,
	doneFolderHelp,
	cancelFolderHelp,
	isNurse,
	helpFoldersMyCenter,
	toggleHelpFolderOfMyCenter,
	user,
	openPreregisterModal,
	reasonOptions,
}) => {
	let history = useHistory();

	function goToFolderManager(folderId) {
		focusFolderManager([folderId]);
		history.push("/home/foldermanager");
	}
	const styles = {
		userContainer: {
			fontSize: "0.7em",
			textAlign: "right",
			lineHeight: "1.5em",
		},
		helpNurseActivated: {
			color: "orange",
			cursor: "pointer",
		},
		helpNurseBell: {
			color: "white",
			cursor: "pointer",
		},
		labelHelpNurseMe: {
			minWidth: "1em",
			minHeight: "1em",
			marginLeft: "-10px",
		},
		labelHelpNurseOthers: {
			minWidth: "1em",
			minHeight: "1em",
			marginLeft: "-5px",
		},
		connected: {
			color: "green",
			minWidth: "4px",
			miHheight: "4px",
			position: "relative",
			lineHeight: "4px",
			top: "6px",
			right: "20px",
		},
		notconnected: {
			color: "red",
			width: "10px",
			height: "10px",
			position: "absolute",
			bottom: "5px",
		},
		labelnotification: {
			marginLeft: "-21px",
			marginBottom: "-21px",
			zIndex: "5",
			fontSize: "9px",
		},
		labelnotificationsec: {
			marginLeft: "-21px",
			marginBottom: "20px",
			zIndex: "5",
			fontSize: "6px",
		},

		bellIcon: {
			marginLeft: "-30px",
			marginBottom: "-18px",
			textShadow: "-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff",
		},
	};

	const [cancelFolderHelpOpen, setcancelFolderHelpOpen] = useState(false);
	const [folderId, setFolderId] = useState(0);
	const closeCancelFolderHelpModal = () => {
		setcancelFolderHelpOpen(false);
	};
	const cancelFolderHelpAndExit = async (folderHelpId, comment, reason) => {
		await cancelFolderHelp(folderHelpId, comment, reason);
		goToFolderManager(folderId);
	};
	const getTotal = (status) => (status ? status.min2 + status.between210 + status.more10 : 0);

	return (
		<>
			<Popup
				content="Télésecrétariat"
				position="right center"
				trigger={
					<Dropdown
						icon={
							<>
								<Icon name="bell" style={{ fontSize: "36px" }} />
								{nurseHelp && !isNurse && <Icon style={styles.bellIcon} corner="bottom right" name="play" color="green" />}
								{!nurseHelp && !isNurse && <Icon style={styles.bellIcon} corner="bottom right" name="pause" color="red" />}
								{isNurse && myNurseFolderHelps.length > 0 && (
									<Label circular color="red" style={styles.labelnotification}>
										{myNurseFolderHelps.filter((f) => f.status === "REASSIGNED").length} / {myNurseFolderHelps.length}
									</Label>
								)}
								{!isNurse && myNurseFolderHelps.length > 0 && <Label circular color="red" style={styles.labelnotificationsec}></Label>}{" "}
							</>
						}
						item
					>
						<Dropdown.Menu style={{ maxHeight: "600px", overflow: "auto" }}>
							{!isNurse && (
								<Dropdown.Item
									onClick={() => toggleNurseHelp()}
									children={
										<div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
											<Icon name={!nurseHelp ? "play circle outline" : "pause circle outline"} color={!nurseHelp ? "green" : "red"} size="big" />
											<span style={{ minWidth: "220px", whiteSpace: "break-spaces" }}>
												{!nurseHelp ? "Se rendre disponible pour le télésecrétariat" : "Désactiver le télésecrétariat"}
											</span>
										</div>
									}
								/>
							)}
							<Dropdown.Header
								onClick={(e) => e.stopPropagation()}
								icon="pin"
								content={
									isNurse ? (
										<span>
											<span style={{ marginRight: "20px" }}>Télésecrétariat</span>
											<span>
												<Checkbox
													style={{ marginRight: "5px", paddingTop: "5px" }}
													checked={helpFoldersMyCenter}
													onMouseDown={(e) => {
														toggleHelpFolderOfMyCenter();
														e.preventDefault();
														e.stopPropagation();
													}}
												/>
												<span style={{ fontSize: "0.8em" }}>Mon centre</span>
											</span>
										</span>
									) : (
										<>
											Télésecrétariat - {getTotal(statusWaitingFolderHelps)} {getTotal(statusWaitingFolderHelps) > 1 ? "dossiers" : "dossier"} en
											attente
											<Segment>
												<Label color="green">
													{" "}
													{statusWaitingFolderHelps.min2}
													<Label.Detail>
														{" "}
														<Icon name="angle left" /> 2 min
													</Label.Detail>
												</Label>
												<Label color="orange">
													{" "}
													{statusWaitingFolderHelps.between210}
													<Label.Detail>
														{" "}
														<Icon name="angle left"></Icon> 10 min{" "}
													</Label.Detail>
												</Label>
												<Label color="red">
													{" "}
													{statusWaitingFolderHelps.more10}
													<Label.Detail>
														{" "}
														<Icon name="angle right"></Icon> 10 min{" "}
													</Label.Detail>
												</Label>
											</Segment>
										</>
									)
								}
							/>

							{myNurseFolderHelps.length > 0 &&
								myNurseFolderHelps
									.slice()
									.sort((a, b) => (a.status === "REASSIGNED" && b.status !== "REASSIGNED" ? -1 : moment(a.updated_at) - moment(b.updated_at)))
									.map((hf) => (
										<DropDownItemFolder
											key={`ddif-${hf.id}`}
											folder={hf}
											fastresult={false}
											acceptSupportFolderHelp={acceptSupportFolderHelp}
											doneFolderHelp={doneFolderHelp}
											cancel={() => {
												setFolderId(hf.folder.id);
												setcancelFolderHelpOpen(true);
											}}
											isNurse={isNurse}
											folderHelp={true}
											focusFolderManager={focusFolderManager}
											user={user}
											openPreregisterModal={openPreregisterModal}
										/>
									))}
						</Dropdown.Menu>
					</Dropdown>
				}
			/>
			<CancelNurseHelpModal
				open={cancelFolderHelpOpen}
				close={closeCancelFolderHelpModal}
				cancelFolderHelp={cancelFolderHelpAndExit}
				folderId={folderId}
				reasonOptions={reasonOptions}
			/>
		</>
	);
};

export default HelpFolderDropDown;
